import { fireAdobeAnalyticsEvent } from './adobe-analytics';

// Launch's Form rules listen for analytics:form:* and read the form name from
// eVar40. One tracker per form keeps every form on the same sequence:
// view, start (first input), error, submit (server accepted), abandon.
export const createFormAnalytics = (formName, getTarget = () => undefined) => {
  let started = false;
  let submitted = false;

  const send = type =>
    fireAdobeAnalyticsEvent(
      { type: `form:${type}`, detail: { eVar40: formName } },
      getTarget() || undefined
    );

  return {
    view() {
      started = false;
      submitted = false;
      send('view');
    },
    start() {
      if (started) return;
      started = true;
      send('start');
    },
    error() {
      send('error');
    },
    submit() {
      submitted = true;
      send('submit');
    },
    // Closes the attempt. Only modals call this: a page can't report its
    // own unload reliably, so page forms read abandons as starts minus sends.
    end() {
      if (started && !submitted) send('abandon');
      started = false;
      submitted = false;
    },
  };
};

// Calls onOpen/onClose as the modal gains or loses .is-open, which every
// open path (MicroModal, modal-panel, hash links) sets.
export const watchModalOpen = (modal, { onOpen, onClose }) => {
  let isOpen = modal.classList.contains('is-open');
  if (isOpen) onOpen();

  new MutationObserver(() => {
    const nowOpen = modal.classList.contains('is-open');
    if (nowOpen === isOpen) return;
    isOpen = nowOpen;
    if (isOpen) onOpen();
    else onClose();
  }).observe(modal, { attributes: true, attributeFilter: ['class'] });
};
